import { render, staticRenderFns } from "./elevatorVideo.vue?vue&type=template&id=c03204da&scoped=true"
import script from "./elevatorVideo.vue?vue&type=script&lang=js"
export * from "./elevatorVideo.vue?vue&type=script&lang=js"
import style0 from "./elevatorVideo.vue?vue&type=style&index=0&id=c03204da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c03204da",
  null
  
)

export default component.exports